/* Keep full product names and reserve equal title rows, including unrated cards. */
(() => {
  const controllers = new Map();
  function init(grid) {
    if (controllers.has(grid)) return;
    let frame = 0, width = -1;
    const update = () => {
      frame = 0;
      if (!grid.isConnected) return;
      const titles = [...grid.querySelectorAll('.finder-card h2')];
      grid.style.removeProperty('--finder-title-slot');
      titles.forEach(title => title.style.removeProperty('font-size'));
      titles.forEach(title => {
        let size = parseFloat(getComputedStyle(title).fontSize);
        while (title.scrollHeight > parseFloat(getComputedStyle(title).lineHeight) * 3 + 1 && size > 14) {
          size -= 1; title.style.fontSize = size + 'px';
        }
      });
      const height = Math.ceil(Math.max(0, ...titles.map(title => title.getBoundingClientRect().height)));
      grid.style.setProperty('--finder-title-slot', height + 'px');
    };
    const queue = () => { if (!frame) frame = requestAnimationFrame(update); };
    const observer = new ResizeObserver(entries => {
      const next = Math.round(entries[0].contentRect.width);
      if (next !== width) { width = next; queue(); }
    });
    observer.observe(grid); queue(); document.fonts?.ready.then(queue);
    controllers.set(grid, () => { observer.disconnect(); cancelAnimationFrame(frame); });
  }
  const boot = scope => scope.querySelectorAll('.finder-grid').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => boot(document)); else boot(document);
  document.addEventListener('shopify:section:load', e => boot(e.target));
  document.addEventListener('shopify:section:unload', e => {
    for (const [grid, dispose] of controllers) if (e.target.contains(grid)) { dispose(); controllers.delete(grid); }
  });
})();
